// project imports
import DrawerHeaderStyled from './DrawerHeaderStyled';

// ==============================|| DRAWER HEADER ||============================== //

export default function DrawerHeader() {
  return (
    <DrawerHeaderStyled
      sx={{
        minHeight: '60px',
        height: '60px',
        width: '100%',
        padding: 0
      }}
    />
  );
}
